import React, { useEffect, useRef, useState } from "react";
import {useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "./QuestionnairesForm.css";
import EditForm from "./EditForm";
import { setTitle } from "../../redux/titleSlice";
import apiClient from '../../services/apiClient';
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import SendToCustomerInfoModal2 from "./SendToCustomerInfoModal2";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";


export default function SendQuestionnairesForm() {

 
  const { eventID,QuestionnairesId } = useParams();
  const title = useSelector((state) => state.title.title);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const childStateRef=useRef();
  const editorRef = useRef(null);
  const [contractCount, setContractCount] = useState(0);
  const [showCustomURLInput, setShowCustomURLInput] = useState(true);

  const [maintitle, setMaintitle] = useState('');
  const [mainplaceholder, setMainplaceholder] = useState('');

  const [questions, setQuestions] = useState([]);


  

  useEffect(() => {
    dispatch(setTitle('Untitled Questionnaires'));
  }, []);

  const handleRadioChange = (event) => {
    setShowCustomURLInput(event.target.value === "custom");
  };

  const [expanded, setExpanded] = useState(false);

  const toggleSidebar = () => {
    setExpanded(!expanded);
  };


  const  handleques = () => {

    
    const questionstate=childStateRef.current.getQuestion();
    const Title_2=childStateRef.current.getTitle2(); 
    const placeholder_2=childStateRef.current.getPlaceholder2();
    setMaintitle(Title_2);
    setMainplaceholder(placeholder_2);
    setQuestions(questionstate);

  };

 
 
 
  useEffect(() => {
    // Create a <style> tag
    const styleTag = document.createElement("style");
    styleTag.innerHTML = "body { background-color: #f1f4f9 !important; }";

    // Append the <style> tag to the head
    document.head.appendChild(styleTag);

    // Cleanup: remove the style when the component unmounts
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);
 

  

  

  const handleSubmit = async () => {


    const questionstate=childStateRef.current.getQuestion();
    const Title_2=childStateRef.current.getTitle2(); 
    const placeholder_2=childStateRef.current.getPlaceholder2(); 

    

    

    try {
      const response = await apiClient.put(`/questionnaires/${QuestionnairesId}`, {
        title: title,
        user_id: JSON.parse(localStorage.getItem('user')).user.id,
        Title2:Title_2,
        placeholder:placeholder_2,
        questions: questionstate.map((tab) => ({
                                                type:tab.type,
                                                showServiceInfo:tab.showServiceInfo,
                                                ques:tab.ques,
                                                ques2:tab.ques2,
                                                placeholder:tab.placeholder,
                                                placeholder2:tab.placeholder2,
                                                option:JSON.stringify(tab.option),
                                                optionadd:tab.optionadd,
          })),
          
      });
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Invoice saved successfully!",
      });
      navigate("/questionnaires");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }

  }


  useEffect(() => {
    const fetchQuestionnaires = async () => {
      try {
        const response = await apiClient.get(`/questionnaires/${QuestionnairesId}`);
       // setContractContent(response.data.pages[0].content);
    // setinvoicetitle(response.data.title);
      

       // setinvoiceitem(response.data.invoice_item);

       // setinvoicepayments(response.data.invoice_payment);


        
        dispatch(setTitle(response.data.title));
        

        setContractCount(response.data.question__pages.length+1);
  
      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchQuestionnaires();
  }, []);

  return (
    <>
     <SendToCustomerInfoModal2  type='Questionnaires' id={QuestionnairesId} title={title} Title2={maintitle} placeholder={mainplaceholder} questionstate={questions}  />
      <div className='container-fluid p-lg-0 py-lg-3 p-md-5 p-3'>
        <div className='row g-lg-5 g-md-5 g-3 px-lg-5'>
        <div className='col-md-12 text-end mt-n1 mb-3'>  
                     
           </div>
          {/*begin: Main form area */}
          <div className='col-md-8 center8'>
            <div className='form_container tab-content '>

                        <div
                            className='tab-pane fade show active'
                            id='v-pills-home'
                            role='tabpanel'
                            aria-labelledby='v-pills-home-tab'
                            tabIndex='0'>
                                <EditForm ref={childStateRef} functioncall={handleques} />
                          </div>

                          
              
            </div>

            <div className="gap2"></div>

            <div className='text-center pt-2'>
                  <button
                      id='submit-btn'
                      type='button'
                      className='px-5 rounded-pill btn btn-primary btn-lg text-uppercase'
                      data-bs-toggle='modal'
                      data-bs-target='#exampleModal2'
                     >
                      Share
                    </button>
               </div>




          </div>
          {/*end: Main form area */}
          {/*begin: Sidebar area */}
          <div className='col-lg-4 center4'> 

                                    <span className='placeholder col-6'></span>

                                            <div className='row'>
                                              <div className='col-12'>
                                                <div className='right-side-area'>
                                                  <div
                                                    className='nav flex-column nav-pills me-3'
                                                    id='v-pills-tab'
                                                    role='tablist'
                                                    aria-orientation='vertical'>


                                                       {/* Current Page Begin: Invoice Box */}
                                            



                                                    {/* Current Page Begin: Invoice Box */}
                                                  

                                                 </div>

                                                 


                                                 








                                            </div>
                                        </div>
                                    </div>                             

            
           
           
           
           {/* <div
              className={`side_bar_contract_form shadow  ${
                expanded ? "aside-menu--expanded" : ""
              }`}>
              <div className='sidebar_header'>
                {!expanded ? (
                  <button
                    type='button'
                    className='mt-3 ms-4 text-black hamburger_side'
                    onClick={toggleSidebar}>
                    <i className='fas fa-times'></i>
                  </button>
                ) : (
                  <button
                    type='button'
                    className='mt-3 ms-4 text-black hamburger_side hamburger_side_mobile'
                    onClick={toggleSidebar}>
                    <i className='fas fa-bars hamburger_side_icon'></i>
                  </button>
                )}
                <h5
                  className={`mb-2 ${
                    expanded ? "aside-menu--expanded-body-content" : ""
                  }`}>
                  Setting
                </h5>
              </div>
              <div
                className={`sidebar_content_body px-2 ${
                  expanded ? "aside-menu--expanded-body-content" : ""
                }`}>
                <div className='form_sidebar'>
                  <div className='sidebar_main'>
                    <div className='sidebar-content'>
                      <h5 className='mb-3'>
                        After Form Complication Redirect To
                      </h5>
                      <div className='form_group position-relative'>
                        <div className='form-check mb-2'>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='redirectOption'
                            id='flexRadioDefault1'
                            value='default'
                            onChange={handleRadioChange}
                            defaultChecked
                          />
                          <div>
                            <label
                              className='form-check-label form-check-label_sidebar label_tooltip'
                              htmlFor='flexRadioDefault1'>
                              Default Thank You Message
                              <span className='ques_arrow'>
                                <i className='fa-solid fa-question'></i>
                              </span>
                            </label>
                            <div className='toolTipContent d-none'>
                              <span>
                                When your client submits a form, well show a
                                default Thank You message to confirm receipt
                              </span>
                              <div className='arrowForm'></div>
                            </div>
                          </div>
                        </div>
                        <div className='form-check'>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='redirectOption'
                            id='flexRadioDefault2'
                            value='custom'
                            onChange={handleRadioChange}
                          />
                          <label
                            className='form-check-label form-check-label_sidebar'
                            htmlFor='flexRadioDefault2'>
                            Your Own Custom URL
                          </label>

                          {showCustomURLInput && (
                            <div className='link_input'>
                              <input
                                type='text'
                                placeholder='https://mywebsite.com/thanks'
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='sidebar-bottom'>
                      <h5 className='mb-3'>SPAM PROTECTION</h5>
                      <p>
                        PB Web App uses Google as your Contact Form Spam
                        Protection
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>*/}
          </div> 
          {/*end: Sidebar area */}
        </div>
      </div>
    </>
  );
}
